import { Dispatch, SetStateAction, useEffect } from "react";

import { useSession } from "./useSession";
import { useUser } from "./useUser";

import TenantData = App.Data.TenantData;
import UserData = App.Data.UserData;

export const useTenantContext = (
    tenant: TenantData,
    user: UserData,
    setInitialized: Dispatch<SetStateAction<boolean>>
) => {
    const sessionUtils = useSession();
    const userUtils = useUser();

    useEffect(() => {
        userUtils.setTenant(tenant);
        sessionUtils.setUser(user);
        setInitialized(true);
    }, [tenant, user, setInitialized]);

    return userUtils.getActiveTenant();
};
